import React from 'react';
import  get  from 'lodash/get';

import Button, { ButtonProps } from '../Button/Button';
import ModalButton from '../ModalButton/ModalButton';
import { LinkComponentFragment, WebsiteLocaleFragment } from '../../../graphql.schema';

type StrapiButtonProps = LinkComponentFragment & {
  className?: string;
  hideIcon?: boolean;
  type?: ButtonProps['type'];
  websiteLocale?: WebsiteLocaleFragment;
  icon?: 'Arrow' | 'Chevron';
};

const StrapiButton: React.FC<StrapiButtonProps> = (props) => {
  const href = props.page?.slug ?? props.url ?? '';
  const modal = get(props, 'cta.modal.data.attributes', props.modal )

  if (modal?.title)
    return (
      <ModalButton type="primary" modalButtonType="button" {...props}>
        {props.children}
      </ModalButton>
    );

  const extraProps = {
    target: props.openInNewWindow ? '__blank' : undefined,
    rel: props.nofollow ? 'nofollow' : undefined,
  };
  return (
    <Button
      className={props.className}
      openInNewWindow={props.openInNewWindow}
      href={href}
      type={props.type}
      hideIcon={props.hideIcon}
      icon={props.icon}
      {...extraProps}
    >
      {props.children ?? props.title}
    </Button>
  );
};

export default StrapiButton;
